import {
  DashboardIcon,
  FullListIcon,
  SupervisorIcon,
  CompanyIcon,
  LocalOfferIcon,
  AllyIcon,
  VerifiedUserIcon,
  InventoryIcon,
  SettingsIcon,
  PlanIcon,
  CategoryIcon,
  SaleIcon,
  InfoIcon,
  CardIcon,
  DollarIcon,
  BankIcon,
  SubscriptionIcon,
  TableIcon,
  WalletIcon,
  GoalIcon,
  UploadImageIcon,
  PhoneIcon,
  MoneyIcon,
} from '@avila-tek/ui/src';
import { roles } from './static';

export interface IRoute {
  text: string;
  href: string;
  as: string;
  privileges: string[];
  icon: JSX.Element;
  isCollapsible?: boolean;
  subLinks?: Array<Partial<IRoute>>;
  show?: boolean;
}

export const routes: IRoute[] = [
  {
    text: 'Dashboard',
    href: '/app/dashboard',
    as: '/app/dashboard',
    privileges: [roles.admin, roles.company, roles.ally],
    isCollapsible: false,
    icon: <DashboardIcon />,
    show: true,
  },
  {
    text: 'Perfil',
    href: '/app/profile',
    as: '/app/profile',
    privileges: [roles.admin, roles.company, roles.ally],
    isCollapsible: false,
    icon: <DashboardIcon />,
    show: false,
  },
  {
    text: 'Gestiona tus compras',
    href: '/app/catalogue',
    as: '/app/catalogue',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <LocalOfferIcon />,
    show: true,
    subLinks: [
      {
        text: 'Categoria',
        href: '/app/catalogue/category',
        as: '/app/catalogue/category',
        privileges: [roles.company],
        isCollapsible: false,
        icon: <CategoryIcon />,
        show: true,
      },
      {
        text: 'Producto',
        href: '/app/catalogue/category/gift-card',
        as: '/app/catalogue/category/gift-card',
        privileges: [roles.company],
        isCollapsible: false,
        icon: <LocalOfferIcon />,
        show: true,
      },
    ],
  },
  {
    text: 'Subscripciones',
    href: '/app/subscriptions',
    as: '/app/subscriptions',
    privileges: [],
    isCollapsible: false,
    icon: <SubscriptionIcon />,
    show: false,
  },
  {
    text: 'Beneficiarios',
    href: '/app/employees',
    as: '/app/employees',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <SupervisorIcon />,
    show: true,
    subLinks: [
      {
        text: 'Grupos',
        href: '/app/employees/groups',
        as: '/app/employees/groups',
        privileges: [roles.company],
        isCollapsible: false,
        icon: <SupervisorIcon />,
        show: false,
      },
    ],
  },
  // {
  //   text: 'Beneficios',
  //   href: '/app/benefits',
  //   as: '/app/benefits',
  //   privileges: [roles.company],
  //   isCollapsible: false,
  //   icon: <SaleIcon />,
  //   show: true,
  // },
  {
    text: 'Órdenes',
    href: '/app/orders',
    as: '/app/orders',
    privileges: [roles.admin, roles.ally, roles.company],
    isCollapsible: false,
    icon: <FullListIcon />,
    show: true,
  },
  {
    text: 'Órdenes',
    href: '/app/trade',
    as: '/app/trade',
    privileges: [roles.admin, roles.ally],
    isCollapsible: false,
    icon: <FullListIcon />,
    show: false,
  },

  {
    text: 'Productos',
    href: '/app/products',
    as: '/app/products',
    privileges: [roles.admin, roles.ally],
    isCollapsible: false,
    icon: <LocalOfferIcon />,
    show: true,
  },
  {
    text: 'Carrito',
    href: '/app/shopcart',
    as: '/app/shopcart',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <LocalOfferIcon />,
    show: false,
  },
  {
    text: 'Información de pago',
    href: '/app/checkout',
    as: '/app/checkout',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <LocalOfferIcon />,
    show: false,
  },
  {
    text: 'Clientes',
    href: '/app/clients',
    as: '/app/clients',
    privileges: [roles.admin],
    isCollapsible: false,
    icon: <SupervisorIcon />,
    show: true,
  },
  {
    text: 'Compañias',
    href: '/app/companies',
    as: '/app/companies',
    privileges: [roles.admin],
    isCollapsible: false,
    icon: <CompanyIcon />,
    show: true,
  },
  {
    text: 'Aliados',
    href: '/app/allies',
    as: '/app/allies',
    privileges: [roles.admin],
    isCollapsible: false,
    icon: <AllyIcon />,
    show: true,
  },
  {
    text: 'Roles y privilegios',
    href: '/app/users',
    as: '/app/users',
    privileges: [roles.admin],
    isCollapsible: false,
    icon: <VerifiedUserIcon />,
    show: true,
  },
  {
    text: 'Estructura',
    href: '/app/structure',
    as: '/app/structure',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <VerifiedUserIcon />,
    show: true,
  },
  {
    text: 'Metas',
    href: '/app/goals',
    as: '/app/goals',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <GoalIcon />,
    show: true,
  },
  {
    text: 'Períodos',
    href: '/app/periods',
    as: '/app/periods',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <GoalIcon />,
    show: false,
    subLinks: [
      {
        text: 'Assignar Período',
        href: '/app/periods/assignPeriod',
        as: '/app/assignPeriod',
        privileges: [roles.company],
        isCollapsible: false,
        icon: <GoalIcon />,
        show: false,
      },
      {
        text: 'Assignar Meta',
        href: '/app/periods/assignTarget',
        as: '/app/assignTarget',
        privileges: [roles.company],
        isCollapsible: false,
        icon: <GoalIcon />,
        show: false,
      },
    ],
  },
  {
    text: 'Solicitudes',
    href: '/app/requests',
    as: '/app/requests',
    privileges: [roles.company],
    isCollapsible: false,
    icon: <TableIcon />,
    show: false,
  },
  {
    text: 'Cuentas por cobrar',
    href: '/app/receivable',
    as: '/app/receivable',
    privileges: [roles.admin],
    isCollapsible: false,
    icon: <WalletIcon />,
    show: true,
  },
  {
    text: 'Cuentas por cobrar',
    href: '/app/ally-receivable',
    as: '/app/ally-receivable',
    privileges: [roles.ally],
    isCollapsible: false,
    icon: <WalletIcon />,
    show: true,
  },
  {
    text: 'Cuentas por pagar',
    href: '/app/payable',
    as: '/app/payable',
    privileges: [roles.admin],
    isCollapsible: false,
    icon: <WalletIcon />,
    show: true,
    subLinks: [
      {
        text: 'Detalle',
        href: '/app/payable/:payableId',
        as: '/app/payable/:payableId',
        privileges: [roles.admin],
        isCollapsible: false,
        icon: <WalletIcon />,
        show: false,
      },
      {
        text: 'Detalle orderProduct',
        href: '/app/payable/:payableId/:orderProductId',
        as: '/app/payable/:payableId/:orderProductId',
        privileges: [roles.admin],
        isCollapsible: false,
        icon: <WalletIcon />,
        show: false,
      },
    ],
  },
  {
    text: 'Pagos',
    href: '/app/payments',
    as: '/app/payments',
    privileges: [roles.admin],
    isCollapsible: true,
    icon: <MoneyIcon />,
    show: true,
    subLinks: [
      {
        text: 'Pagos móviles',
        href: '/app/payments/pago-movil',
        as: '/app/payments/pago-movil',
        privileges: [roles.admin],
        isCollapsible: false,
        icon: <PhoneIcon />,
        show: false,
      },
    ],
  },
  {
    text: 'Mantenimiento',
    href: '/app/maintenance',
    as: '/app/maintenance',
    privileges: [roles.admin],
    isCollapsible: true,
    icon: <InventoryIcon />,
    show: true,
    subLinks: [
      {
        icon: <PlanIcon />,
        href: '/app/maintenance/plans',
        as: '/app/maintenance/plans',
        text: 'Planes',
        show: true,
      },
      {
        icon: <CategoryIcon />,
        href: '/app/maintenance/categories',
        as: '/app/maintenance/categories',
        text: 'Categorías',
        show: true,
      },
      {
        icon: <SaleIcon />,
        href: '/app/maintenance/sales',
        as: '/app/maintenance/sales',
        text: 'Promociones',
        show: true,
      },
    ],
  },
  {
    text: 'Configuración',
    href: '/app/settings',
    as: '/app/settings',
    privileges: [roles.admin],
    show: true,
    isCollapsible: true,
    icon: <SettingsIcon />,
    subLinks: [
      {
        icon: <CardIcon />,
        href: '/app/settings/payment',
        as: '/app/settings/payment',
        text: 'Métodos de pago',
        show: true,
      },
      {
        icon: <DollarIcon />,
        href: '/app/settings/currencies',
        as: '/app/settings/currencies',
        text: 'Monedas',
        show: true,
      },
      {
        icon: <BankIcon />,
        href: '/app/settings/taxes',
        as: '/app/settings/taxes',
        text: 'Impuestos',
        show: true,
      },
      {
        icon: <UploadImageIcon />,
        href: '/app/settings/banner',
        as: '/app/settings/banner',
        text: 'Gestionar banner',
        show: true,
      },
      {
        icon: <InfoIcon />,
        href: '/app/settings/terms-and-conditions',
        as: '/app/settings/terms-and-conditions',
        text: 'Terminos ',
        show: true,
      },
      {
        icon: <SupervisorIcon />,
        href: '/app/settings/frequently-asked-question',
        as: '/app/settings/frequently-asked-question',
        text: 'Preguntas',
        show: true,
      },
    ],
  },
];
